import { spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  container: {
    justifyContent: "space-between",
    height: spacing.l + spacing.xxs,
  },
  text: {
    fontSize: 11,
    fontWeight: 500,
  },
  light: {
    opacity: 0.34,
  },
};
